import Vue from 'vue'
import Vuex from 'vuex'
import API from "@/js/api"
import session from '@/store/modules/session.js'
import style from '@/store/modules/styles.js'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    hasNotSavedChanges:false,
    saving:false,
    loadingLinks:false,
    links:[],
    demoLinks:[
        {
          name:"This is your first link",
          url:"https://misred.es",
          icon:"youtube",
          order: 0
        },
      ],
  },
  getters:{
    links:state => state.links,
    loadingLinks:state => state.loadingLinks,
    isLinkInDatabase:(state)=>(index)=> state.links[index].id != null
  },
  mutations: {
    setLoadingLinks: (state,loading) => state.loadingLinks = loading,
    setLinks (state,links) {
      state.links = links
    },
    fillWithDemoLinks:(state)=> state.links = state.demoLinks,
    addLink(state){
      state.links.push( {
          name:"",
          url:"",
          icon:"facebook",
          order:state.links.length
        })
    },
    indexOrder(state,from = 0){
      for (let i = from; i < state.links.length; i++) {
          state.links[i].order = i;  
        }
    },
    // se le agega su id de la db a un link recien agregado
    updateAddedIds(state,newInfo){
      for (let i = 0; i < state.links.length; i++) {
        if(state.links[i].id == null)
          state.links[i].id = newInfo[i].id;  
      }
    },
    deleteLinkFromStore(state,index){
      state.links.splice(index,1);
      // reIndex order
      for (let i = index; i < state.links.length; i++) {
        state.links[i].order = i;  
      }
    },
  },
  actions:{
    getLinks({commit},name){
      commit('setLoadingLinks',true)
      return API.links.get(name).then((json)=>{
        commit('setLoadingLinks',false)        
        commit('setLinks',json)
      },()=>{})
    },
    deleteLinkFromDatabase(_,id){
      return API.links.delete(id)
    },
    removeLink({dispatch,commit,getters},index){
      if(getters.isLinkInDatabase(index)){
        let id = getters.links[index].id
        dispatch('deleteLinkFromDatabase',id).then(()=>{
          commit('deleteLinkFromStore',index)
        },()=>{
          //hanlde error
        })
      } else {
        commit('deleteLinkFromStore',index)
      }
    },
    setHttpToLinks(_,links){
      links.map((link)=>{
        if (!link.url)
            return
        if (!link.url.includes("https://") && !link.url.includes("http://") ){
          link.url = "https://"+ link.url;
        }
      })
      return links
    },
    saveLinkChange({dispatch,commit,getters,state}){
      //if its already sending data we dont send another request to saca
      // until response
      if(!state.saving){
        state.saving = true;
        dispatch('setHttpToLinks',state.links)
        API.links.post(getters.userName,{"links":state.links}).then((new_info)=>{
          //we finish saving
          commit('updateAddedIds',new_info)
          state.saving = false;
          if(state.hasNotSavedChanges){
            state.hasNotSavedChanges = false;
            dispatch('saveLinkChange')
          }
        })
      } else {
        state.hasNotSavedChanges = true;
      }
    },
  },
  modules:{
    session:session,
    style:style
  }
})

export default store